import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    nothingFound: '',
    actions: 'p-1',
    actionsGroup: 'txt-xs-plus',
  },
  styles: {},
}));
